import { useSignal } from "@preact/signals-react";
import { useStore, insertRecord } from "storev2/formStore";

import FormField from "componentsv2/form/FormField";
import Dialog from "componentsv2/modal/Dialog";
import SearchWindow from "componentsv2/widgets/SearchWindow";
import BoardForm from "componentsv2/form/BoardForm";
import { SearchIcon, PencilSquareIcon, PlusCircleIcon } from "components/Icons";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const style =
  "flex group rounded-md w-full p-2 text-gray-700 border border-slate-300 focus-within:border focus-within:border-cyan-500";

function SearchField(props) {
  const {
    label,
    name,
    field,
    data,
    readOnly,
    model,
    layout,
    parentRec,
    required,
    placeholder,
    onChange,
  } = props;
  // const [placeholder, setPlaceholder] = useState(null);
  // const [mode, setMode] = useState(null);
  const openModal = useSignal(false);
  const openRecord = useSignal(false);
  const mode = useSignal(null);
  const formStoreId = useSignal(null);

  const { newRecord } = useStore();

  let bgColor = "bg-white";
  if (field.readOnly) {
    bgColor = colors.readOnly;
  }

  function onSelectedRecord(rec) {
    console.log("record seleccionado....", rec);
    data.value = rec;
    if (onChange) onChange(name, data.value);
  }

  function searchClicked() {
    if (field.readOnly) {
      return;
    }
    openModal.value = true;
  }

  async function onChangeView(action) {
    mode.value = action;
    let storeId;
    if (action === "edit") {
      const recordId = data.value?.id;
      if (!recordId) return;
      storeId = await insertRecord(recordId, model, layout);
    } else {
      storeId = await newRecord(layout, undefined);
    }
    formStoreId.value = storeId;
    openRecord.value = true;
  }

  function onCloseSearch() {
    openModal.value = false;
  }

  function onCloseRecord(mustReload) {
    if (mustReload?.value) {
      const state = useStore.getState();
      const record = state[formStoreId.value];
      if (record) {
        onSelectedRecord(record.active);
      }
    }
    openRecord.value = false;
    mode.value = null;
    formStoreId.value = null;
  }

  function selectedItem(data) {
    onSelectedRecord(data[0]);
  }

  let widgetIcon;

  if (data.value && field.edit !== false) {
    // if (data.value) {
    widgetIcon = (
      <button
        type="button"
        className="px-2"
        onClick={() => onChangeView("edit")}
      >
        <PencilSquareIcon className="h-6 w-6 fill-current flex my-auto text-sky-400" />
      </button>
    );
  } else {
    widgetIcon = (
      <button
        type="button"
        className="pl-1 pr-2"
        onClick={() => onChangeView("create")}
      >
        <PlusCircleIcon className="h-7 w-7 fill-current flex my-auto text-sky-500/60" />
      </button>
    );
  }

  const value = data.value ? data.value.rec_name || data.value.name : "";

  return (
    <FormField label={label} name={name} required={required} model={model}>
      <div className="flex">
        <div
          className={cn(
            style,
            bgColor,
            theme.textColor,
            theme.input.height,
            theme.border,
          )}
        >
          <input
            type="text"
            disabled={readOnly}
            value={value}
            placeholder={placeholder}
            readOnly
            className="w-full focus:border-none focus:outline-none"
          />
          <SearchIcon
            onClick={searchClicked}
            className="fill-current h-5 w-5 text-neutral-400 active:text-sky-600 cursor-pointer active:scale-90"
            aria-hidden="true"
          />
        </div>
        {/* volver a habilitar estos botones */}
        {widgetIcon}
        {openModal.value && (
          <SearchWindow
            modeSelect="one"
            open={openModal}
            onClose={onCloseSearch}
            layout={layout}
            storeId={model}
            title={layout.model}
            onSelectedRecord={onSelectedRecord}
          />
        )}
        {openRecord.value && mode.value && formStoreId.value && (
          <Dialog
            openModal={openRecord}
            handleClose={onCloseRecord}
            size="w-full md:w-1/2 max-h-[90vh]"
            title={layout.model}
          >
            <BoardForm
              storeId={formStoreId.value}
              layout={layout}
              onClose={onCloseRecord}
              view="modal"
            />
          </Dialog>
        )}
      </div>
    </FormField>
  );
}

export default SearchField;
